import {useContext, useEffect, useState} from 'react';
import MemberContext from '../contexts/MemberContext';
import OutOfStockExperimentsContext from '../contexts/OutOfStockExperimentsContext';

const useOOSTopSort = () => {
  const {
    memberId,
    member: {wedding_date: weddingDate},
  } = useContext(MemberContext);
  const [shouldTopSort, setShouldTopSort] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const {hasOutOfStockItems, isDeterminingOutOfStock} = useContext(
    OutOfStockExperimentsContext,
  );

  const weddingIsInRange =
    weddingDate &&
    new Date(weddingDate) < new Date().getTime() + 1000 * 60 * 60 * 24 * 30 * 3;

  useEffect(() => {
    if (isDeterminingOutOfStock) return;
    if (weddingIsInRange && hasOutOfStockItems) {
      setShouldTopSort(true);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }, [hasOutOfStockItems, weddingIsInRange, isDeterminingOutOfStock, memberId]);

  return {isLoading, shouldTopSort};
};

export default useOOSTopSort;
